import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";

// Define the context type
type SatelightContextType = {
  isMinEyeClickSatelight: boolean;
  setIsMinEyeClickSatelight: (value: boolean) => void;
  selectSatelight: (value: string) => void;
  satelightListMapAdd: (key: string, value: string) => void;
  satelightListMap: Map<string, string>;
  receivedSatelliteTime: (timeData: string[]) => void;
  satelliteTime: string[];
  satelightListOpen: (key: string, value: boolean) => void;
  openSatelightList: Map<string, boolean>;
  setIsSatelightClickProvider: (value: string) => void; // Fix: function type
  isSatelightClickProvider: string;
};

const SatelightContext = createContext<SatelightContextType | undefined>(
  undefined
);

export const SatelightProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {

  const [isMinEyeClickSatelight, setIsMinEyeClickSatelight] = useState(false);
  const [satelightListMap, setSatelightListMap] = useState(new Map<string, string>());
  const [satelliteTime, setSatelliteTime] = useState<string[]>([]);
  const [openSatelightList, setOpenSatelightListMap] = useState(new Map<string, boolean>());
   const [isSatelightClickProvider, setIsSatelightClickProvider] = useState<string>("satelliteNotClick"); 

  const selectSatelight = (satId: string) => {};

  const satelightListMapAdd = (key: string, value: string) => {
    setSatelightListMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(key, value);
      return newMap;
    });
  };

  const satelightListOpen = (key: string, value: boolean) => {
    setOpenSatelightListMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(key, value);
      return newMap;
    });
  };

  const receivedSatelliteTime = (timeData: string[]) => {
    setSatelliteTime((prevTimes) => [...prevTimes, ...timeData]);
  };

  return (
    <SatelightContext.Provider
      value={{
        isMinEyeClickSatelight,
        setIsMinEyeClickSatelight,
        selectSatelight,
        satelightListMapAdd,
        satelightListMap,
        receivedSatelliteTime,
        satelliteTime,
        satelightListOpen,
        openSatelightList,
        setIsSatelightClickProvider,
        isSatelightClickProvider
      }}
    >
      {children}
    </SatelightContext.Provider>
  );
};

// Custom hook for using SatelightContext
export const useSatelightContext = () => {
  const context = useContext(SatelightContext);
  if (!context) {
    throw new Error("useHzContext must be used within an HzProvider");
  }
  return context;
};
